export default {
  data: () => ({
    startDate: "",
    finishDate: "",
    startDateOpen: false,
    finishDateOpen: false,
  }),
  methods: {
    finishDateMethod(data) {
      this.finishDate = data;
    },
    startDateMethod(data) {
      this.startDate = data;
    },
    startDateOpenMethod() {
      this.startDateOpen = true;
    },
    finishDateOpenMethod() {
      this.finishDateOpen = true;
    },
    startDateFunction() {
      if (this.startDateOpen == true) this.startDateOpen = false;
    },
    finishDateFunction() {
      if (this.finishDateOpen == true) this.finishDateOpen = false;
    },
  },
};
